import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Card,
  Typography,
  Table,
  InputNumber,
  Space,
  message,
  Select,
  Input,
  DatePicker,
  Drawer,
  Tooltip,
  Badge,
  Modal,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { ExpenseServices } from "../../../../Services/Manage/ExpenseServices";
import { ServicetypeService } from "../../../../Services/Manage/ServicetypeService";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import SubscriptionDropdown from "../../../general/SubscriptionDropdown";
import CreateUB from "./CreateUB";
import UbType from "./ubType";
import BillPayments from "../../../modals/BillPayments";

const { Title } = Typography;
const { RangePicker } = DatePicker;

const ManageUtilityBill = () => {
  const [activeTab, setActiveTab] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editingValues, setEditingValues] = useState({});
  const [originalData, setOriginalData] = useState([]);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [vendorOption, setVendorOption] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [searchText, setSearchText] = useState("");
  const [grandTotal, setGrandTotal] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const navigate = useNavigate();
const [selectedBill, setSelectedBill]= useState(null);
const [billPaymentData, setBillPaymentData] = useState({});
  

  // Fetch expenses by bill type
  const getAllExpense = async (id) => {
    try {
      const request = await ExpenseServices.getAllExpenseByBillid(id || activeTab?.id);
      setOriginalData(request.data || []);
      // console.log("+++++++",request.data );
      
    } catch (error) {
      console.error(error);
      messageApi.error("Failed to fetch expenses");
    }
  };

  // Fetch vendors
  const GetAllVendors = async () => {
    try {
      const request = await ServicetypeService.getAllVendors();
      setVendorOption(
        request.data.map((v) => ({
          label: v.name,
          value: v.id,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    GetAllVendors();
  }, []);
const fetchBillPaymentData = async (billId) => {
  try {
    const response = await ExpenseServices.getPaymentByBillId(billId);
    const totalPaid = (response?.data || []).reduce(
      (sum, p) => sum + Number(p.paid_amt || 0),
      0
    );
    setBillPaymentData((prev) => ({
      ...prev,
      [billId]: totalPaid,
    }));
  } catch (error) {
    console.error("Error fetching bill payments:", error);
    setBillPaymentData((prev) => ({
      ...prev,
      [billId]: 0,
    }));
  }
};
 const handlePayNow = async (record) => {
  try {

    const grand_total = record?.data?.reduce((sum, item) => {
      const price = Number(item.totalprice) || 0;
      const taxPercent = Number(item.tax) || 0;

      const taxAmount = (price * taxPercent) / 100;

      return sum + price + taxAmount;
    }, 0);

    setGrandTotal(grand_total);

    console.log("record+_+",record);
    setSelectedBill(record);

    setPaymentModalOpen(true);

  } catch (error) {
    console.log(error);
  }
};


  // Handle UB type change
  const handleUbTypeChange = (selectedTab) => {
    if (!selectedTab?.id) return;
    setActiveTab(selectedTab);
    getAllExpense(selectedTab.id);
    
    console.log(selectedTab.id);
  };

  // -------- GROUP BY BILL-ID --------
  const groupedBills = useMemo(() => {
    if (!originalData.length) return [];

    const groups = originalData.reduce((acc, item) => {
      const bill = item.bill_id || "UNKNOWN-BILL";

  if (!acc[bill]) {
  acc[bill] = {
    bill_id: bill,
    vendor_id: item.vendor_id,
    vendor_name:
      vendorOption.find((v) => v.value === item.vendor_id)?.label || "Unknown",
    data: [],
    added_on: item.added_on,
    updated_on: item.updated_on,
  };
  fetchBillPaymentData(bill);  // ← ADD THIS LINE
}

      acc[bill].data.push(item);
      return acc;
    }, {});

    return Object.values(groups);
  }, [originalData, vendorOption]);

  // -------- FILTERING --------
  const filteredBills = useMemo(() => {
    const lower = searchText.toLowerCase();
    const [start, end] = dateRange;

    return groupedBills
      .map((bill) => {
        const filteredItems = bill.data.filter((item) => {
          const vendorName =
            vendorOption.find((v) => v.value === item.vendor_id)?.label || "";

          const matchesSearch =
            item.description?.toLowerCase().includes(lower) ||
            vendorName.toLowerCase().includes(lower) ||
            bill.bill_id.toLowerCase().includes(lower);

          const addedOn = item.added_on ? new Date(item.added_on) : null;
          const matchesDate =
            !start || !end || !addedOn || (addedOn >= start && addedOn <= end);

          return matchesSearch && matchesDate;
        });

        if (filteredItems.length === 0) return null;

        return { ...bill, data: filteredItems };
      })
      .filter(Boolean);
  }, [groupedBills, searchText, dateRange, vendorOption]);

  // -------- EDITING --------
  const handleEdit = (record) => {
  setEditingRow(record.id);

  setEditingValues({
    // Multi item fields
    description: record.description || "",
    qty: record.qty || "",
    tax: record.tax || "",
    unitprice: record.unitprice || "",
    expense_date: record.expense_date
      ? dayjs(record.expense_date).format("YYYY-MM-DD")
      : null,

    subscription_type: record.subscription_type || "",

    date: record.date
      ? dayjs(record.date).format("YYYY-MM-DD")
      : "",
    category: record.category || "",
    asset_name: record.asset_name || "",
    source_of_supply: record.source_of_supply || "",
    comments: record.comments || "",
    totalprice: record.totalprice || "",
  });
};


  const handleSave = async (record) => {
    try {
      const updated = {
        description: editingValues.description,
        qty: editingValues.qty,
        tax: editingValues.tax,
        unitprice: editingValues.unitprice,
        totalprice: (editingValues.qty || 0) * (editingValues.unitprice || 0),
        expense_date: editingValues.expense_date,
        subscription_type: editingValues.subscription_type,
        bill_type: activeTab?.id,

        date: editingValues.date ? dayjs(editingValues.date).format("YYYY-MM-DD") : "",
        category: editingValues.category || "",
        asset_name: editingValues.asset_name || "",
        source_of_supply: editingValues.source_of_supply || "",
        comments: editingValues.comments || "",
        totalprice: editingValues.totalprice || "",

      };

      const req = await ExpenseServices.updateExpense(updated, record.id);
      if (req.status) {
        messageApi.success(req.message);
        getAllExpense();
      } else {
        messageApi.warning(req.message);
      }
    } catch (err) {
      console.error(err);
      messageApi.error("Update failed");
    }

    setEditingRow(null);
    setEditingValues({});
  };

  const handleDelete = async (record) => {
    try {
      const req = await ExpenseServices.deleteExpense(record.id);
      if (req.status) {
        messageApi.success(req.message);
        getAllExpense();
      }
    } catch (err) {
      console.error(err);
      messageApi.error("Delete failed");
    }
  };

  const handleClearFilters = () => {
    setSearchText("");
    setDateRange([null, null]);
  };

  // --------- COLUMNS ---------
  const vendorColumns = [
    { title: "Bill ID", dataIndex: "bill_id", render: (t) => <b>{t}</b> },
    { title: "Vendor", dataIndex: "vendor_name", render: (t) => <b>{t}</b> },
    { title: "Items", align: "center", render: (_, r) => r.data.length },
  {
  title: "Total Expense",
  align: "center",
  render: (_, r) => {
    const total = r.data?.reduce((sum, item) => {
      const price = Number(item.totalprice) || 0;
      const taxPercent = Number(item.tax) || 0;

      const taxAmount = (price * taxPercent) / 100;

      return sum + price + taxAmount;
    }, 0);

    return Number(total).toFixed(2);
  }
},
 // ✅ PAID AMOUNT
{
  title: "Paid Amount",
  align: "center",
  render: (_, r) => {
    const paid = billPaymentData[r.bill_id] || 0;
    return Number(paid).toFixed(2);
  },
},

// ✅ PENDING AMOUNT
{
  title: "Pending Amount",
  align: "center",
  render: (_, r) => {
    const total = r.data?.reduce((sum, item) => {
      const price = Number(item.totalprice) || 0;
      const taxPercent = Number(item.tax) || 0;
      const taxAmount = (price * taxPercent) / 100;
      return sum + price + taxAmount;
    }, 0);

    const paid = billPaymentData[r.bill_id] || 0;
    const pending = total - paid;

    return Number(pending).toFixed(2);
  },
},

  // ✅ PAYMENT STATUS
  {
    title: "Status",
    align: "center",
    render: (_, r) => {
      const total = r.data?.reduce((sum, item) => {
        const price = Number(item.totalprice) || 0;
        const taxPercent = Number(item.tax) || 0;
        const taxAmount = (price * taxPercent) / 100;
        return sum + price + taxAmount;
      }, 0);

      const paid = billPaymentData[r.bill_id] || 0;

      let status = "Pending";
      if (paid === 0) status = "Pending";
      else if (paid < total) status = "Partially Paid";
      else if (paid >= total) status = "Paid";

      return (
        <b
          style={{
            color:
              status === "Paid"
                ? "green"
                : status === "Partially Paid"
                ? "orange"
                : "red",
          }}
        >
          {status}
        </b>
      );
    },
  },
    {
      title: "Added",
      align: "center",
      render: (_, r) =>
        r.added_on
          ? new Date(r.added_on).toLocaleDateString("en-GB")
          : "—",
    },
    {
      title: "Updated",
      align: "center",
      render: (_, r) =>
        r.updated_on
          ? new Date(r.updated_on).toLocaleDateString("en-GB")
          : "—",
    },
    {
      title: "Action",
      align: "center",
      render: (_, r) =>
        <Button onClick={()=>handlePayNow(r)} type="primary">Pay Now</Button>
    },
  ];



  const generalColumns = [
    { title: "S.No", render: (_, __, i) => i + 1, align: "center" },
    {
      title: "Description",
      dataIndex: "description",
      render: (_, record) =>
        editingRow === record.id ? (
          <TextArea
            value={editingValues.description}
            onChange={(e) =>
              setEditingValues({ ...editingValues, description: e.target.value })
            }
          />
        ) : (
          record.description
        ),
    },
    {
      title: "Qty",
      render: (_, record) =>
        editingRow === record.id ? (
          <InputNumber
            value={editingValues.qty}
            onChange={(v) => setEditingValues({ ...editingValues, qty: v })}
          />
        ) : (
          record.qty
        ),
    },
    {
      title: "Subscription Date",
      render: (_, record) =>
        editingRow === record.id ? (
          <input
            type="date"
            value={editingValues.expense_date || ""}
            onChange={(e) =>
              setEditingValues({ ...editingValues, expense_date: e.target.value })
            }
            style={{ width: "100%" }}
          />
        ) : record.expense_date ? (
          new Date(record.expense_date).toLocaleDateString("en-CA")
        ) : (
          ""
        ),
    },
    {
      title: "Alert",
      align: "center",
      render: (_, r) => {
        if (!r.expense_date) return null;
        const due = new Date(r.expense_date);
        const diff = Math.floor((due - new Date()) / 86400000);
        if (diff >= 0 && diff <= 7)
          return (
            <Tooltip title={`Due ${due.toLocaleDateString("en-CA")}`}>
              <Badge color="red" />
            </Tooltip>
          );
        return null;
      },
    },
    {
      title: "Subscription Type",
      render: (_, r) =>
        editingRow === r.id ? (
          <SubscriptionDropdown
            value={editingValues.subscription_type}
            onChange={(v) =>
              setEditingValues({ ...editingValues, subscription_type: v })
            }
          />
        ) : (
          r.subscription_type
        ),
    },
    {
      title: "Unit Price",
      render: (_, r) =>
        editingRow === r.id ? (
          <InputNumber
            value={editingValues.unitprice}
            onChange={(v) => setEditingValues({ ...editingValues, unitprice: v })}
          />
        ) : (
          r.unitprice
        ),
    },
    {
      title: "Tax",
      render: (_, r) =>
        editingRow === r.id ? (
          <InputNumber
            value={editingValues.tax}
            onChange={(v) => setEditingValues({ ...editingValues, tax: v })}
          />
        ) : (
          r.tax
        ),
    },
    {
      title: "Total",
      render: (_, r) =>
        editingRow === r.id
          ? (editingValues.qty || 0) * (editingValues.unitprice || 0)
          : r.totalprice,
    },
    {
      title: "Action",
      render: (_, r) =>
        editingRow === r.id ? (
          <Space>
            <Button type="primary" onClick={() => handleSave(r)}>
              Save
            </Button>
            <Button danger onClick={() => setEditingRow(null)}>
              Cancel
            </Button>
          </Space>
        ) : (
          <Space>
            <Button onClick={() => handleEdit(r)}>Edit</Button>
            <Button danger onClick={() => handleDelete(r)}>Delete</Button>
          </Space>
        ),
    },
  ];

    // SUBTABLE FOR MULTIPLE ITEMS
  const multiItemColumns = generalColumns;

  // SUBTABLE FOR SINGLE ITEM
  const singleItemColumns = [
  {
    title: "Date",
    dataIndex: "date",
    render: (_, record) =>
      editingRow === record.id ? (
        <input
          type="date"
          value={editingValues.date || ""}
          onChange={(e) =>
            setEditingValues({ ...editingValues, date: e.target.value })
          }
          style={{ width: "100%" }}
        />
      ) : record.date ? (
        new Date(record.date).toLocaleDateString("en-CA")
      ) : (
        ""
      ),
  },

  {
    title: "Category",
    dataIndex: "category",
    render: (_, record) =>
      editingRow === record.id ? (
        <Input
          value={editingValues.category}
          onChange={(e) =>
            setEditingValues({ ...editingValues, category: e.target.value })
          }
        />
      ) : (
        record.category
      ),
  },

  {
    title: "Asset Name",
    dataIndex: "asset_name",
    render: (_, record) =>
      editingRow === record.id ? (
        <Input
          value={editingValues.asset_name}
          onChange={(e) =>
            setEditingValues({ ...editingValues, asset_name: e.target.value })
          }
        />
      ) : (
        record.asset_name
      ),
  },

  {
    title: "Source Of Supply",
    dataIndex: "source_of_supply",
    render: (_, record) =>
      editingRow === record.id ? (
        <Input
          value={editingValues.source_of_supply}
          onChange={(e) =>
            setEditingValues({
              ...editingValues,
              source_of_supply: e.target.value,
            })
          }
        />
      ) : (
        record.source_of_supply
      ),
  },

  {
    title: "Comments",
    dataIndex: "comments",
    render: (_, record) =>
      editingRow === record.id ? (
        <Input
          value={editingValues.comments}
          onChange={(e) =>
            setEditingValues({ ...editingValues, comments: e.target.value })
          }
        />
      ) : (
        record.comments
      ),
  },

  {
    title: "Total",
    align: "center",
    // render: (_, record) => Number(record.totalprice || 0).toFixed(2),
    render: (_, record) =>
        editingRow === record.id ? (
          <InputNumber
            value={editingValues.totalprice}
            onChange={(v) => setEditingValues({ ...editingValues, totalprice: v })}
          />
        ) : (
          record.totalprice
        ),
  },

  {
    title: "Action",
    render: (_, record) =>
      editingRow === record.id ? (
        <Space>
          <Button type="primary" onClick={() => handleSave(record)}>
            Save
          </Button>
          <Button danger onClick={() => setEditingRow(null)}>
            Cancel
          </Button>
        </Space>
      ) : (
        <Space>
          <Button onClick={() => handleEdit(record)}>Edit</Button>
          <Button danger onClick={() => handleDelete(record)}>Delete</Button>
        </Space>
      ),
  },
];



  return (
    <>
      {contextHolder}

      <Modal
        width={800}
        title={
          <Typography.Title level={4}>Add Payment for: {selectedBill?.bill_id}</Typography.Title>
        }
        open={paymentModalOpen}
        onCancel={() => setPaymentModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        {selectedBill && <BillPayments getAllExpense={getAllExpense} quotationNo={selectedBill?.bill_id} grandTotal={grandTotal} />}
      </Modal>

      <Card
        title={<Title level={4}>Manage Utility Bills</Title>}
        extra={
          <Button size="large" onClick={() => navigate("/manage-vendor")}>
            Add Vendor
          </Button>
        }
      >
        <Card style={{ marginBottom: 16 }}>
          <Space wrap>
            <Input
              allowClear
              placeholder="Search..."
              size="large"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 350 }}
            />
            <RangePicker
              size="large"
              format="DD MMM YYYY"
              onChange={(dates) =>
                dates
                  ? setDateRange([
                    dates[0].startOf("day").toDate(),
                    dates[1].endOf("day").toDate(),
                  ])
                  : setDateRange([null, null])
              }
            />
            <Button onClick={handleClearFilters}>Clear</Button>
          </Space>
        </Card>

        <UbType getAllExpense={getAllExpense} onUbTypeChange={handleUbTypeChange} />

        <Table
          rowKey="bill_id"
          dataSource={filteredBills}
          columns={vendorColumns}
          expandable={{
            expandedRowRender: (bill) => {
              const isSingle = bill.data.length === 1;

              return (
                <Table
                  rowKey="id"
                  dataSource={bill.data}
                  columns={isSingle ? singleItemColumns : multiItemColumns}
                  pagination={false}
                  size="small"
                />
              );
            },
          }}

          pagination={{ pageSize: 10 }}
        />
      </Card>

    <Drawer
  title={<Title level={4}>Create Utility Bill</Title>}
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  width={1500}
  destroyOnClose
>

    <CreateUB
  activeBillType={activeTab?.id}
  getAllExpense={getAllExpense}
  onClose={() => setDrawerOpen(false)}
/>

      </Drawer>
    </>
  );
};

export default ManageUtilityBill;